// import { Meeting } from "@platform/types/platform.types";
import moment from "moment";
import { Download } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Meeting } from "@platform/types/platform.types";
import { generateICSLinkForMeetingArray } from "../utils/generateICSLinkForMeetingArray";

export type Props = {
  meeting: Meeting;
  onClick?: () => void;
  eventTitle: string;
  eventDescription?: string;
  eventUrl?: string;
  onAddCalendarEvent: (
    meetingId: number,
    calendarType: "google" | "ical"
  ) => void;
};

export function AddToICalButton({
  meeting,
  onClick,
  eventTitle,
  eventDescription,
  eventUrl,
  onAddCalendarEvent,
}: Props) {
  const handleClick = () => {
    const { link, url } = generateICSLinkForMeetingArray({
      meetings: [meeting],
      eventTitle: eventTitle,
      eventDescription: eventDescription,
      eventUrl: eventUrl,
      outputFileName: "pollinator-meetings.ics",
    });

    onAddCalendarEvent(meeting.id, "ical");

    link.click();

    URL.revokeObjectURL(url);

    onClick?.();
  };

  return (
    <Button variant="secondary" iconComponent={Download} onClick={handleClick}>
      Add to iCal
    </Button>
  );
}

export default AddToICalButton;
